/**
 * @file
 * Accessibility for cookie-banner
 */

(($) => {
  const $bodyElement = $("body");
  const showCookieBanner = "js-eu-cookie-compliance-button";
  Drupal.behaviors.cookieCompliance = {
    attach: () => {
      $(".eu-cookie-withdraw-tab").keyup((e) => {
        if (e.which === 9) {
          if (!$bodyElement.hasClass("eu-cookie-compliance-popup-open")) {
            Drupal.eu_cookie_compliance.toggleWithdrawBanner();
          }
        }
      });

      $("a[href='#eu-cookie-withdraw-consent']").on("click", () => {
        if ($bodyElement.hasClass(showCookieBanner)) {
          $bodyElement.removeClass(showCookieBanner);
        }
        $bodyElement.removeClass(showCookieBanner);
        Drupal.eu_cookie_compliance.toggleWithdrawBanner();
      });
    },
  };
  $(window).on("load", () => {
    if (Drupal.eu_cookie_compliance.getCookieStatus() === 1) {
      Drupal.eu_cookie_compliance.savePreferencesAction();
    }
    $(".eu-cookie-compliance-save-preferences-button").on("click", () => {
      $bodyElement.removeClass("eu-cookie-compliance-popup-open");
      $bodyElement.addClass(showCookieBanner);
      Drupal.eu_cookie_compliance.setStatus(1);

    });
    if (Drupal.eu_cookie_compliance.hasAgreed()) {
      $bodyElement.addClass(showCookieBanner);
    }
    if (!Drupal.eu_cookie_compliance.hasAgreed()) {
      Drupal.eu_cookie_compliance.toggleWithdrawBanner();
      $bodyElement.removeClass(showCookieBanner);
    }
  });

  $(document).on(
    "click",
    ".eu-cookie-compliance-save-preferences-button",
    () => {
      if (Drupal.eu_cookie_compliance.getAcceptedCategories([]).length > 1) {
        const set_cookie_session_zero_on_disagree = parseInt( /* eslint-disable-line camelcase */
          drupalSettings.eu_cookie_compliance
            .set_cookie_session_zero_on_disagree
        , 10);
        if (set_cookie_session_zero_on_disagree) { /* eslint-disable-line camelcase */
          drupalSettings.eu_cookie_compliance.cookie_session = 1;
        }
        Drupal.eu_cookie_compliance.setStatus(1);
        Drupal.eu_cookie_compliance.setAcceptedCategories([]);
        window.location.reload();
      }
      $(".eu-cookie-compliance-save-preferences-button").on("click", () => {
        Drupal.eu_cookie_compliance.savePreferencesAction();
        $bodyElement.removeClass("eu-cookie-compliance-popup-open");
        $bodyElement.addClass(showCookieBanner);
        Drupal.eu_cookie_compliance.setStatus(1);
      });
    }
  );
})(jQuery);
